// bulbal: cấu hình build-time cho fork "Bulbal Chat" (SSO HRM + tinh gọn UI).
// File thuần config — không import module có side-effect để an toàn khi import ở nhiều nơi.
// Xem plan: plans/20260729-0735-tinode-chat-sso-integration/phase-03-webapp-fork-sso.md

// URL cấp ticket đăng nhập một lần từ HRM. Hardcode tuyệt đối domain — KHÔNG lấy từ query
// param/window.location để chống SSRF/phishing (xem plan §Security Considerations).
export const BULBAL_HRM_TICKET_URL = 'https://hrm.bulbalvn.com/api/tinode/ticket';

// Ngôn ngữ mặc định của giao diện — bỏ qua browser-detect, vẫn cho override bằng #?hl=xx.
export const BULBAL_DEFAULT_LANG = 'vi';

// Timeout (ms) khi gọi HRM lấy ticket. Quá hạn -> rơi về form đăng nhập thủ công.
export const BULBAL_SSO_FETCH_TIMEOUT_MS = 8000;

// URL mint ICE servers (STUN + TURN Cloudflare, credential ngắn hạn) cho voice/video call.
// Hardcode tuyệt đối domain như BULBAL_HRM_TICKET_URL. Xem src/bulbal-turn.js.
// LƯU Ý 260730: call machinery gốc Tinode đã bị THAY bằng RealtimeKit (bulbal-call.js) —
// bulbal-turn.js/URL này giữ lại dormant, không còn được gọi trong flow chính.
export const BULBAL_HRM_TURN_URL = 'https://hrm.bulbalvn.com/api/tinode/turn-credentials';

// Timeout (ms) khi mint TURN credential. Quá hạn -> gọi tiếp với STUN-only từ server param
// (NAT dễ vẫn nối được P2P, NAT khó sẽ rớt — chấp nhận thay vì chặn cuộc gọi).
export const BULBAL_TURN_FETCH_TIMEOUT_MS = 3000;

// Cuộc gọi/họp nhóm RealtimeKit (thay call gốc Tinode, 260730). Xem src/bulbal-call.js.
export const BULBAL_HRM_CALL_CREATE_URL = 'https://hrm.bulbalvn.com/api/tinode/call/create';
export const BULBAL_CALL_FETCH_TIMEOUT_MS = 10000;

// Công tắc probe chuông TOÀN CỤC (thử nghiệm — reo cả khi đang ở hội thoại khác bằng cách
// kéo 1 tin mới nhất của topic vừa báo 'msg'). Có vấn đề (fan-out/va chạm subscribe) → đặt
// false + rebuild là tắt sạch. Chi tiết: bulbal-call.js §probe.
export const BULBAL_GLOBAL_RING_PROBE = true;

// Cờ tinh gọn UI theo quyết định 260729 (xem plan §UI Scope). Mỗi cờ tương ứng 1 chỗ ẩn có
// comment `// bulbal:` tại nơi dùng — không xoá file/route upstream, chỉ ẩn có điều kiện.
export const BULBAL_UI_SCOPE = {
  // Ẩn nút "Đăng ký" (icon person_add) trong menu màn đăng nhập + chặn điều hướng hash #register.
  hideSignUp: true,
  // Ẩn link "Quên mật khẩu?" trong form đăng nhập + chặn điều hướng hash #reset.
  hidePasswordReset: true,
  // Ẩn khối đổi mật khẩu trong acc-security-view (giữ nguyên nút đăng xuất).
  hideChangePassword: true,
  // Mục "Gọi thoại"/"Gọi video": ĐÃ BẬT 260730 — TURN qua Cloudflare (mint credential tại
  // /api/tinode/turn-credentials, xem bulbal-turn.js + plans/20260730-0753-bulbal-chat-voice-call-cf-turn/).
  hideCallButtons: false,
  // Khóa sửa tên + avatar trong hồ sơ "me" — đồng bộ một chiều từ hồ sơ HRM.
  lockNameAvatar: true,
  // Ẩn nút "Xóa tài khoản" (acc-security-view): tài khoản do HRM cấp qua SSO. NV tự xóa sẽ để
  // lại mapping tinode_accounts trỏ uid đã chết -> lần đăng nhập sau hỏng. Vòng đời tài khoản
  // do HR quản (offboarding), không phải người dùng cuối. (Phát hiện khi test UI 260729.)
  hideDeleteAccount: true,
};

// Thông điệp tiếng Việt cố định cho luồng SSO — dùng đúng nguyên văn theo phase-03 §Architecture.
export const BULBAL_SSO_MESSAGES = {
  pending: 'Đang đăng nhập bằng tài khoản HRM…',
  sessionExpired: 'Phiên HRM đã hết hạn. Vui lòng đăng nhập lại tại hrm.bulbalvn.com rồi mở lại trang này.',
  notActiveEmployee: 'Tài khoản của bạn chưa được kích hoạt để dùng chat.',
  genericFail: 'Không đăng nhập tự động được. Bạn có thể đăng nhập thủ công bên dưới.',
  iosPushNotice: 'iPhone/iPad chưa nhận được thông báo đẩy khi đóng trình duyệt — hãy mở ứng dụng Tinode để nhận thông báo.',
};

// Ghi chú thương hiệu dùng trong UI (title tab, document.title động khi có tin chưa đọc).
export const BULBAL_APP_TITLE = 'Bulbal Chat';
